<template>
  <div id="guarantees">
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-button
              @click="createWarranty(null)"
              class="bg_l_green float-left"
              v-has-permission="permission135"
            >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
              {{ $t("CreateNewCompany") }}
            </vs-button>
          </div>
        </div>
        <modify-popup
          :show="ModifyPopup"
          :model="modalModel"
          @finish="onfinish"
        ></modify-popup>

        <div class="vx-row">
          <div
            class="vx-col w-full mb-base"
            v-for="(company, companyIndex) in allWarranties"
            :key="company.id"
            style="padding-bottom: 8%"
          >
            <vs-table>
              <template slot="thead">
                <vs-th style="width: 12%">#</vs-th>
                <vs-th style="width: 22%">{{ $t("WarrantyName") }}</vs-th>
                <vs-th style="width: 22%">{{ $t("Description") }}</vs-th>
                <vs-th style="width: 22%">{{ $t("WarrantyCode") }}</vs-th>
                <vs-th style="width: 22%">{{ $t("Action") }}</vs-th>
              </template>
              <template slot-scope="{}">
                <vs-td>
                  {{ companyIndex + 1 }}
                </vs-td>
                <vs-td>{{ company.name }}</vs-td>
                <vs-td>{{ company.description }}</vs-td>
                <vs-td>{{ company.id }}</vs-td>
                <vs-td>
                  <div class="mb-4 mt-3 flex btn-actions">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-plus"
                      class="mr-2 add-c"
                      @click.prevent="createWarranty(company.id)"
                      v-has-permission="permission135"
                    ></vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      class="mr-2 edit-c"
                      @click.prevent="editWarranty(company)"
                      v-has-permission="permission136"
                    ></vs-button>
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-x"
                      class="mr-2 remove-c"
                      @click.prevent="deleteWarranty(company.id)"
                      v-has-permission="permission137"
                    ></vs-button>
                  </div>
                </vs-td>
              </template>
            </vs-table>
            <vs-table
              :data="company.children"
              stripe
              v-if="company.children && company.children.length"
              style="width: 70%; margin: auto"
            >
              <template slot="thead">
                <vs-th style="width: 12%">#</vs-th>
                <vs-th style="width: 22%">{{
                  $t("TypeAndTermsOfWarranty")
                }}</vs-th>
                <vs-th style="width: 22%">{{ $t("Description") }}</vs-th>
                <vs-th style="width: 22%">{{ $t("WarrantyCode") }}</vs-th>
                <vs-th style="width: 22%">{{ $t("Action") }}</vs-th>
              </template>
              <template slot-scope="{}" class="myform">
                <vs-tr
                  v-for="(item, warrantyIndex) in company.children"
                  :key="item.Id"
                >
                  <vs-td :data="warrantyIndex" class="index-td">
                    {{ warrantyIndex + 1 }}
                  </vs-td>
                  <vs-td :data="item.Name">
                    {{ item.name }}
                  </vs-td>
                  <vs-td :data="item.Description">
                    {{ item.description }}
                  </vs-td>
                  <vs-td :data="item.id">
                    {{ item.id }}
                  </vs-td>
                  <vs-td>
                    <span>
                      <vs-button
                        radius
                        color="success"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-edit"
                        @click.prevent="editWarranty(item)"
                        class="ml-4 d-inline"
                        v-has-permission="permission136"
                      ></vs-button>
                      <vs-button
                        radius
                        color="danger"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.prevent="deleteWarranty(item.id)"
                        class="d-inline"
                        v-has-permission="permission137"
                      ></vs-button>
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
* {
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import ModifyPopup from "./CreateAndModifyPopup.vue";
export default {
  data() {
    return {
      permission135: "CreateWarranty",
      permission136: "ModifyWarranty",
      permission137: "DeleteWarranty",
      ModifyPopup: false,
      modalModel: {},
      itemList: []
    };
  },
  computed: {
    ...mapGetters({
      allWarranties: "warranty/list"
    })
  },
  mounted() {
    this.fetchWarranties();
  },
  methods: {
    ...mapActions({
      fetchWarranties: "warranty/fetch",
      removeWarranty: "warranty/remove"
    }),
    //Open Modal In Create Mode
    createWarranty(parent) {
      if (parent == null) {
        this.modalModel = {};
      } else {
        this.modalModel = { parent: parent };
      }
      this.ModifyPopup = true;
    },
    //Open Modal In Edit Mode
    editWarranty(model) {
      if (model.parentId == null) {
        this.modalModel = {
          id: model.id,
          name: model.name,
          description: model.description,
          logoUri: model.logoUri
        };
      } else {
        this.modalModel = {
          id: model.id,
          name: model.name,
          description: model.description,
          parent: model.parentId
        };
      }
      this.ModifyPopup = true;
    },
    //Delete Method
    deleteWarranty(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",

        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر"
      }).then(result => {
        if (result.value) {
          this.removeWarranty(id).then(() => {});
        }
      });
    },
    onfinish() {
      this.ModifyPopup = false;
    },
    submitForm() {}
  },
  components: {
    ModifyPopup
  }
};
</script>
